import { BaseLookupModel, PaginationFilterRequest } from "./core.model";

export interface StoryChapter {
  id: number;
  name: string;
  description: string;
  bannerUrl: string;
  order: number;
  minimumStar: number;
  isIntro: boolean;
  storyId: number;
}
export interface StoryChapterList {
  id: number;
  name: string;
  description: string;
  bannerUrl: string;
  order: number;
  minimumStar: number;
  isIntro: boolean;
  storyId: number;
  tasks: number;
  medias: number;
}


export interface UpsertStoryChapter {
  id?: number;
  name?: string;
  description?: string;
  bannerUrl?: string;
  order?: number;
  minimumStar?: number;
  isIntro?: boolean;
  storyId?: number;
}

export class StoryChapterPaginationFilterRequest extends PaginationFilterRequest{  
    storyId?: number;
}
